/** Fixed datasets owned by Event Container Movement. */
export enum EventContainerMovementWorkspaceCapabilityUdoTemplateKey {
    operation = "2d166f05-870a-44bf-b5bd-e1aee1079ba1",
    operationItem = "ad460a50-3da7-4f1c-b3bf-e7924c64cc9d",
    audit = "6d05cac2-2c63-4568-a303-1b45e1f294b7",
}
